import React from 'react';
import { CTAButton } from './CTAButton';
import { MockupImage } from './MockupImage';
import { OFFER_ANCHOR } from '../data/constants';
export function FinalCTA() {
  return <section className="border-t-4 border-brandorange bg-carbon py-8 sm:py-10" data-id="element-44" data-mp="c6smjmqagifh">
      <div className="mx-auto max-w-[1080px] px-4 sm:px-6" data-id="element-45" data-mp="c4o7q9qupz0f">
        <h2 className="text-center text-[24px] font-bold leading-none text-white sm:text-[36px]" data-id="element-46" data-mp="844dpf1krbii">
          One last <span className="text-brandorange" data-id="element-47" data-mp="m3ngdsbm9unf">question</span>
        </h2>
        <p className="mx-auto mt-3 max-w-[780px] text-center text-[14px] font-medium leading-snug text-metal sm:text-[17px]" data-id="element-48" data-mp="h6nbvluf0zyf">
          When another motorcycle fault appears... Do you immediately know what
          needs to be tested first? Stop jumping between scattered references and
          guessing where the problem starts. Open the system. Find the symptom.
          Follow the diagnostic path.{' '}
          <strong className="font-bold text-white" data-id="element-49" data-mp="zxei4ej3wa8l">
            Identify. Test. Diagnose.
          </strong>
        </p>

        <MockupImage className="mt-5" data-id="element-50" data-mp="2c67sapgt7m91" />

        <div className="mt-5 text-center" data-id="element-51" data-mp="2h3rhuliyjlga">
          <p className="font-display text-[20px] uppercase leading-none text-white sm:text-[28px]" data-id="element-52" data-mp="2h4izesfpzink">
            🏍️ Motorcycle Diagnostic Pro™
          </p>
          <p className="mx-auto mt-2 max-w-[640px] text-[13px] font-semibold uppercase leading-tight tracking-wide text-metal sm:text-[16px]" data-id="element-53" data-mp="2r1np328rxw94">
            The complete visual troubleshooting system for motorcycle technicians
          </p>
          <p className="mt-2 font-display text-[12px] uppercase tracking-[0.14em] text-brandorange sm:text-[15px]" data-id="element-54" data-mp="301as1sh5ja4a">
            Understand • Identify • Test • Isolate • Diagnose • Verify
          </p>
        </div>

        <div className="mt-4 flex flex-col items-center" data-id="element-55" data-mp="39rvpvdp04am5">
          <p className="mb-3 font-display text-[16px] uppercase leading-tight text-mod-yellow sm:text-[21px]" data-id="element-56" data-mp="3es1hitv9tx48">
            🔥 Get the complete system today
          </p>
          <CTAButton href={OFFER_ANCHOR} data-id="element-57" data-mp="3iqqrsdl0iyjn">
            ⚡ Get Motorcycle Diagnostic Pro™
          </CTAButton>
          <p className="mt-3 text-center font-display text-[11.5px] uppercase tracking-wide text-metal sm:text-[13px]" data-id="element-58" data-mp="1ep8spydzfmbh">
            Immediate Access • Digital Delivery{' '}
            <span className="mx-1 text-line" data-id="element-59" data-mp="1sirmn747hmsb">|</span> 🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}